// extracted by mini-css-extract-plugin
module.exports = {"textarea":"styles__textarea___35Bcx","textarea--error":"styles__textarea--error___27mUZ"};